import Adapter from "@/adapters/base";
import { AxiosResponse } from 'axios';


const baseAdapter = new Adapter();

class FeatureFlags {

    //Basics:
    frontendBaseUrl: string = "";
    backendBaseUrl: string = "";

    //All properties with defaults:
    usersEnabled: boolean = false;
    enforceLogin: boolean = false;
    enableTracking: boolean = false;

    //Free tier (with default limits if the backend fails to provide these):
    defaultExpiryInDays: number = 14;
    freeTierTransferLimit: number = 100000000; //100MB
    freeTierFileLimit: number = 1;
    billingPeriodInDays: number = 14;
    transferBillingUnit: number = 100000000; //100MB

    //Theming:
    showPresentedBy: boolean = true;
    presentedByLogoAddress: string = "/img/uniki_logo.svg";
    presentedByLogoClickUrl: string = "https://uniki.de";

    async fetchFromServer() {
        try {
            const res: AxiosResponse = await baseAdapter.request({
                method: 'get',
                url: '/features',
            });

            Object.assign(this, res.data);

            //the code expects these properties to be absolute:
            if (this.frontendBaseUrl === "") {
                this.frontendBaseUrl = window.location.origin;
            }
            if (this.backendBaseUrl === "") {
                this.backendBaseUrl = window.location.origin;
            }

        } catch (e) {
            console.error("Fetching features failed, using defaults");
        }
    }

}

const featureFlags: FeatureFlags = new FeatureFlags();
export default featureFlags;
